import { render } from "./SpeedColorLevel.vue?vue&type=template&id=79b48c74&scoped=true"
import script from "./SpeedColorLevel.vue?vue&type=script&lang=js"
export * from "./SpeedColorLevel.vue?vue&type=script&lang=js"

import "./SpeedColorLevel.vue?vue&type=style&index=0&id=79b48c74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b48c74"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QPopupProxy,QColor,QBtn,QTooltip});
